export const apiConfigs = {
    baseURL : "https://www.telcarnet.com/",
};
